exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.event[data-v-457f50f4] {\n  border-top-left-radius: 4px;\n  border-top-right-radius: 4px;\n}\n.event .image[data-v-457f50f4] {\n    width: 165px;\n    height: 165px;\n    overflow: hidden;\n}\n.event .image > img[data-v-457f50f4] {\n      width: 165px;\n      max-height: 165px;\n}\n.event .logo[data-v-457f50f4] {\n    position: absolute;\n    top: 0.5rem;\n    right: 0.5rem;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"id":"data-v-457f50f4","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/reservations/BasicData.vue
// module id = 2178
// module chunks = 0